module.exports = __webpack_public_path__ + "fa-solid-900.605ed7926cf39a2ad5ec.ttf";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-solid-900.ttf
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-solid-900.ttf
// module chunks = styles